import { render } from "./hrms-documents.vue?vue&type=template&id=75583681&scoped=true"
import script from "./hrms-documents.vue?vue&type=script&lang=js"
export * from "./hrms-documents.vue?vue&type=script&lang=js"

import "./hrms-documents.vue?vue&type=style&index=0&id=75583681&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75583681"]])

export default __exports__